module.exports = __webpack_public_path__ + "static/media/sass.87be3f3b.svg";